<script>
    import {locale, language } from '@src/languages'
    import {postResource,logout} from '@src/service'
    import routerManager from '@src/router/router'

    
    const router = routerManager.getRouter('default')
    let old_password = null
    let new_password = null
    let re_new_password = null
    let match_error = false    
    

    let trials = 0 ;
    let password_changed = false
    let countdownStart = 3

    function countdown(){
        const x = setInterval(()=>{
              countdownStart --;
              if(countdownStart <= 0){
                  clearInterval(x)
                  
                  logout()
              }  
        },1000)
    }


    function handleSubmit() {
      
        console.log('submit')
        if(!checkPassMatch()) return ;        

        postResource('changepass',{
            current_password:old_password,
            newpassword:new_password,
            newpassword2: re_new_password
        })
        .subscribe( p =>{                       
            p.then(data => {
                password_changed = true
                countdown()
                
            })
            .catch(error => {
                console.log(error)
                trials ++
            })           
        })
    }

    $: if(trials > 3) {   
        logout()
    }

    function  checkPassMatch(){                
        match_error =  !(new_password == re_new_password)
        return !match_error
    }

    function cancel(){
        router.navigate('settings')
    }
    
</script>

<div class="w-full h-full">
        <h1 class="text-center text-2xl mt-2">{ $language.label_change_pass}</h1>
        <h2 class="text-center p-2 text-red-600 text-lg" class:invisible={trials==0}>
                 { $language.warn_message_pass_trials(trials) }
        </h2>
        <h2 class="text-center p-2" class:invisible={!password_changed}>
            { $language.success_message_pass_changed(countdownStart)}
            </h2>
    
        <form  on:submit|preventDefault={handleSubmit} class="flex flex-col gap-3 p-4 mt-4">
            <div>
                <label  for="password" class="mb-2 block px-2 font-bold">
                    <span>{$language.label_password}</span>
    
                </label>
                <input name="password" type="password" bind:value={old_password} class="w-full p-1 rounded-full border-2 border-green-400">
            </div>
            <div>
                <label  for="new_password" class="mb-2 block px-2 font-bold">
                    <span>{$language.label_new_password}</span>
                </label>
                <input   name="new_password" type="password" bind:value={new_password} class="w-full p-1 rounded-full border-2 border-green-400">
            </div>
            <div>
                <label  for="re_new_password" class="mb-2 block px-2 font-bold">
                    <span>{$language.label_re_new_password}</span>
                    <span class:invisible={!match_error} class="text-sm text-red-400">({$language.error_message_password_dont_match})</span>
                </label>
                <input on:blur={checkPassMatch} name="re_new_password" type="password" bind:value={re_new_password} class="w-full p-1 rounded-full border-2 {match_error?'border-red-400':'border-green-400'}">
            </div>
            <div class="flex flex-row gap-4 mt-10">
                <button  on:click={cancel}
                    class=" text-white text-center p-2 font-bold rounded-full  w-full bg-gray-400">
                    {$language.btn_cancel}                    
                </button>
                <button  type="submit" 
                class=" text-white text-center font-bold rounded-full  w-full bg-green-400">
                {$language.btn_save}                    
            </button>
            </div>
            
        </form>

</div>
